import _regeneratorRuntime from 'babel-runtime/regenerator';
import _asyncToGenerator from 'babel-runtime/helpers/asyncToGenerator';
import _Math$trunc from 'babel-runtime/core-js/math/trunc';
import _extends from 'babel-runtime/helpers/extends';

import _ from 'lodash';
import { mapActions } from 'vuex';
import { linkageMixin } from '../mixin/linkage';

export default {
  mixins: [linkageMixin],

  props: {
    category: {
      type: Object,
      required: true
    },

    updateTargetCategory: {
      type: Function,
      required: true
    }
  },

  data: function data() {
    return {
      visible: false,
      volume: 50
    };
  },


  computed: {
    catVolume: function catVolume() {
      // 从接口中获取的音量需要加50
      var volume = _.get(this.category, 'properties.volume');
      if (_.isNumber(volume)) {
        return volume + 50;
      }
      return 50;
    }
  },

  watch: {
    catVolume: function catVolume() {
      this.transVolume();
    }
  },

  methods: _extends({}, mapActions({
    livePreview: 'creative/template/livePreview',
    livePreviewResources: 'creative/template/livePreviewResources'
  }), {
    transVolume: function transVolume() {
      this.volume = _Math$trunc(this.catVolume);
    },
    changeVolume: function changeVolume(val) {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var properties;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                properties = _extends({}, _this.category.properties || {}, {
                  // 提交给接口时需要减50
                  volume: val - 50
                });
                _context.next = 3;
                return _this.updateTargetCategory({
                  properties: properties,
                  id: _this.category.id
                });

              case 3:
                _this.livePreviewResources();

              case 4:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    }
  }),

  mounted: function mounted() {
    this.transVolume();
  }
};